module.exports = [{"id":0,"val":"白"},{"id":1,"val":"绿"},{"id":2,"val":"蓝"},{"id":3,"val":"紫"},{"id":4,"val":"橙"},{"id":5,"val":"红"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/war_groove_quality.json
// module id = XpQ3
// module chunks = 1